import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import IntermediateUseSoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import intermediateIcon from "../../../../../assets/design-revamp-company/category-icons/intermediate-use-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const IntermediateUseContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="use-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("COMP_INTERMEDIATE_TITLE")}
          subDescription={t("COMP_INTERMEDIATE_DESC")}
          isNormal={true}
          number={"16.3"}
          icon={intermediateIcon}
        />
      </div>
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-intermediateusesold-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <IntermediateUseSoldTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default IntermediateUseContents;
